import {SvgAsset} from '*.svg';

export function buildIconAttributes(attributes: SvgAsset['attributes'], size?: number) {
  // The `dimensionsFromViewbox` is computed at build time, see the webpack config.
  const {viewBox, dimensionsFromViewbox, stroke} = attributes;
  const widthFromViewBox = dimensionsFromViewbox && dimensionsFromViewbox.width;
  const heightFromViewBox = dimensionsFromViewbox && dimensionsFromViewbox.height;
  const width = size || widthFromViewBox || attributes.width;
  const height = size || heightFromViewBox || attributes.height;

  return {height, width, viewBox, stroke};
}
